<template>
  <section ref="strip" class="s-news">
    <div class="page-container">
      <Loader v-if="isLoading" display="absolute"></Loader>
      <Alert
        v-if="errorMsgs.length"
        type="danger"
        :messages="errorMsgs"></Alert>

      <!--#region s-news__filters-->
      <div class="s-news__filters">
        <div class="s-news__filters__country">
          <div class="form-group b-lbl-inpt b-lbl-inpt--inline">
            <label class="form-wrap__label">{{ dictionary.yearsLabel }}</label>

            <div class="input-wrap">
              <select v-model="year" class="form-select" @change="onChangeYear">
                <option
                  v-for="item in years"
                  :key="item.value"
                  :value="item.value">
                  {{ item.text }}
                </option>
              </select>
            </div>
          </div>
        </div>

        <div class="s-news__filters__sort">
          <div class="b-vehicleSorting">
            <div class="b-vehicleSorting__foundPages">
              <span>
                {{ recordsCountFiltered }} {{ dictionary.totalResultsSuffix }}
              </span>

              <span v-if="showPagination">
                &nbsp;| {{ itemsPerPage }} {{ dictionary.itemsPerPageSuffix }}
              </span>
            </div>

            <div
              v-if="showPagination"
              class="b-vehicleSorting__btn"
              data-v-if="showPagination">
              <button
                type="button"
                class="btn btn-outline-primary"
                @click="onClickShowAll">
                {{ dictionary.buttonShowAllText }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <!--#endregion-->
      <!--#region s-news__results-->
      <div class="s-news__results mb-40">
        <div class="s-news__items">
          <div
            v-for="item in recordsFilteredPaged"
            :key="item.Lnk"
            class="s-news__item">
            <NewsItem :item="item" />
          </div>
        </div>
      </div>
      <div v-if="!recordsCountFiltered">
        <NoResults></NoResults>
      </div>

      <div v-if="recordsCountFiltered" class="d-flex justify-content-center">
        <Pagination
          :total-records="recordsCountFiltered"
          :per-page="itemsPerPage"
          :current-page="page"
          @pagechanged="pageChanged" />
      </div>
    </div>
  </section>
</template>

<script>
import mixins from './../mixins/mixins'
import jQuery from 'jquery'
import axios from 'axios'
import Loader from '../components/common/Loader.vue'
import Alert from '../components/common/Alert.vue'
import NoResults from '../components/common/NoResults.vue'
import Pagination from './../components/common/Pagination.vue'
import * as lib from '../../lib/lib'
import { v4 as uuidv4 } from 'uuid'
import NewsItem from './../components/NewsItem.vue'
/* eslint-disable no-unused-vars */
import { head, uniqBy } from 'lodash'

export default {
  components: { Loader, Alert, NoResults, Pagination, NewsItem },
  mixins: [mixins],
  data() {
    return {
      isLoading: false,
      errorMsgs: [],
      years: [],
      year: '',

      page: 1,
      pageSize: 9,
      itemsPerPage: 0,

      records: [],
      recordsCount: null,
      recordsFiltered: [],
    }
  },
  computed: {
    showPagination() {
      return this.itemsPerPage < 999
    },
    recordsFilteredPaged() {
      const start = (this.page - 1) * this.itemsPerPage
      const end = this.page * this.itemsPerPage

      return this.recordsFiltered.slice(start, end)
    },

    recordsCountFiltered() {
      return this.recordsFiltered.length
    },
  },
  mounted() {
    const { years } = lib.getData('newsData')

    this.years = years
    this.itemsPerPage = this.configuration.itemsPerPage
    this.setPreselectedValues()

    this.fetchData()
  },
  methods: {
    fetchData() {
      this.isLoading = true

      const formData = new FormData()
      formData.append('yearCode', this.year)

      axios
        .post(
          this.configuration.endpointFetchData,
          formData,
          this.getAxiosConfig()
        )
        .then((response) => {
          const { News } = response.data

          this.records = this.recordsFiltered = News
          this.recordsCount = this.records.length
          this.key = uuidv4()

          this.handleSuccess()
        })
        .catch((errors) => {
          this.handleError([this.dictionary.defaultErrorMessage])
          console.error(errors)
        })
    },

    handleSuccess() {
      this.errorMsgs = []
      this.isLoading = false
    },

    handleError(messages) {
      this.errorMsgs = messages
      this.isLoading = false
    },

    onClickShowAll() {
      this.page = 1
      this.itemsPerPage = 999
    },

    setPreselectedValues() {
      const entry = this.years.find((i) => i.selected)
      this.year = entry ? entry.value : ''
    },

    onChangeYear() {
      this.page = 1
      this.itemsPerPage = this.configuration.itemsPerPage
      this.fetchData()
    },

    pageChanged(value) {
      this.page = value
      lib.scrollToElem(jQuery(this.$refs.strip), 100)
    },
  },
}
</script>
